import { useI18n } from 'vue-i18n';

export enum CarModel {
  G30 = 'K02503/K02504',
  P100 = 'K06706'
}
export enum Country {
  US = 'US',
  CA = 'CA'
}
const enum Urls {
  howtoImgP100 = 'https://oms-oss-public.ninebot.com/website/support/new-howto-pc.png',
  howtoImgG30 = 'https://oms-oss-public.ninebot.com/website/support/new-howto-pc-G30.png',
  howtoImgG30M = 'https://oms-oss-public.ninebot.com/website/support/new-howto-mobile_G30.png',
  howtoImgP100M = 'https://oms-oss-public.ninebot.com/website/support/new-howto-mobile.png'
}

// 使用示例
console.log(Urls.howtoImgP100); // 输出: https://oms-oss-public.ninebot.com/website/support/new-howto-pc.png

export function recallData() {
  const { t } = useI18n();
  return {
    validationRulesMap: {
      [CarModel.P100]: {
        serialNumberText: t('recall.recall_fault_serial_number_text'),
        snRegExp: /^(S2GK|s2gk)\w{1}(2308|2310|2311)\w{5}$/i,
        findNumberText: t('recall.recall_modal_list_2'),
        howtoImg: Urls.howtoImgP100,
        howtoImgM: Urls.howtoImgP100M,
        warnReminder1: t('recall.warn_reminder_1'),
        warnReminder2: t('recall.warn_reminder_2'),
        warnReminderBold: t('recall.warn_reminder_1_bold'),
        validatePostalCodeText: {
          [Country.US]: t('recall.recall_form_postal_holder'),
          [Country.CA]: t('recall.recall_form_postal_holder')
        },
        postalCodeRegExp: {
          [Country.US]: /^[a-zA-Z0-9\- ]{1,10}$/,
          [Country.CA]: /^[a-zA-Z0-9\- ]{1,10}$/
        }
      },
      [CarModel.G30]: {
        serialNumberText: t('recall.recall_fault_serial_number_text_2'),
        snRegExp: /^(N4GN|N4GS)[A-Za-z0-9]{10}$/i, // 前四位N4GN/N4GS，长度10位
        findNumberText: t('recall.recall_modal_list_G30_2'),
        howtoImg: Urls.howtoImgG30,
        howtoImgM: Urls.howtoImgG30M,
        warnReminderUrl_1: t('recall.recall_warning_reminder_url_1'),
        warnReminderUrl_2: t('recall.recall_warning_reminder_url_2'),
        warnReminderWarning: t('recall.recall_warning'),
        warnReminderInstruction: t('recall.recall_maintainenance_instruction'),
        warnReminder1: t('recall.warn_reminder_G30_1'),
        warnReminder2: t('recall.warn_reminder_G30_2'),
        warnReminderBold: t('recall.warn_reminder_G30_1_bold'),
        validatePostalCodeText: {
          [Country.US]: t('recall.recall_form_postal_holder_G30_US'),
          [Country.CA]: t('recall.recall_form_postal_holder_G30_CA')
        },
        postalCodeRegExp: {
          [Country.US]: /^(?:\d{5}|\d{5}-\d{4})$/,
          [Country.CA]: /^[a-zA-Z0-9 ]{1,7}$/
        }
      }
    },
    processStepsMapPc: {
      [CarModel.G30]: [
        {
          type: 'step',
          name: 'ic_recall_process_1',
          textKey: 'recall.recall_process_content_1'
        },
        { type: 'arrow' },
        {
          type: 'step',
          name: 'ic_recall_process_2',
          textKey: 'recall.recall_process_content_2'
        },
        { type: 'arrow' },
        {
          type: 'step',
          name: 'ic_recall_process_3',
          textKey: 'recall.recall_process_content_3'
        },
        { type: 'arrow' },
        {
          type: 'step',
          name: 'ic_recall_process_4',
          textKey: 'recall.recall_process_content_4'
        },
        {
          type: 'arrow'
        },
        {
          type: 'step',
          name: 'ic_recall_process_5',
          textKey: 'recall.recall_process_content_5'
        }
      ],
      [CarModel.P100]: [
        {
          type: 'step',
          name: 'ic_recall_process_1',
          textKey: 'recall.recall_process_content_1'
        },
        { type: 'arrow' },
        {
          type: 'step',
          name: 'ic_recall_process_3',
          textKey: 'recall.recall_process_content_6'
        },
        { type: 'arrow' },
        {
          type: 'step',
          name: 'ic_recall_process_4',
          textKey: 'recall.recall_process_content_7'
        },
        { type: 'arrow' },
        {
          type: 'step',
          name: 'ic_recall_process_6',
          textKey: 'recall.recall_process_content_8'
        }
      ]
    },
    recallQA: [
      {
        title: 'recall.recall_suc_refund_question',
        content: 'recall.recall_suc_refund_answer'
      },
      {
        title: 'recall.recall_suc_replacement_question',
        content: 'recall.recall_suc_replacement_answer'
      },
      {
        title: 'recall.recall_suc_segway_adjustment_question',
        content: 'recall.recall_suc_segway_adjustment_answer'
      },
      {
        title: 'recall.recall_suc_adjustment_question',
        content: 'recall.recall_suc_adjustment_answer'
      },
      {
        title: 'recall.recall_suc_cover_shipping_question',
        content: 'recall.recall_suc_cover_shipping_answer'
      },
      {
        title: 'recall.recall_suc_boxes_question',
        content: 'recall.recall_suc_boxes_answer'
      },
      {
        title: 'recall.recall_suc_stores_question',
        content: 'recall.recall_suc_stores_answer'
      },
      {
        title: 'recall.recall_suc_maintenance_question',
        content: 'recall.recall_suc_maintenance_answer'
      },
      {
        title: 'recall.recall_suc_repair_center_question',
        content: 'recall.recall_suc_repair_center_answer'
      },
      {
        title: 'recall.recall_suc_warranty_case_question',
        content: 'recall.recall_suc_warranty_case_answer'
      },
      {
        title: 'recall.recall_suc_model_question',
        content: 'recall.recall_suc_model_answer'
      },
      {
        title: 'recall.recall_suc_damages_compensated_question',
        content: 'recall.recall_suc_damages_compensated_answer'
      },
      {
        title: 'recall.recall_suc_injured_compensated_question',
        content: 'recall.recall_suc_injured_compensated_answer'
      },
      {
        title: 'recall.recall_suc_check_maintenance_question',
        content: 'recall.recall_suc_check_maintenance_answer'
      },
      {
        title: 'recall.recall_suc_other_question',
        content: 'recall.recall_suc_other_answer'
      },
      {
        title: 'recall.recall_suc_more_question',
        content: 'recall.recall_suc_more_answer'
      },
      {
        title: '',
        content: 'recall.recall_suc_maintenance_video'
      }
    ]
  };
}
